import { PricingItem, QuoteService } from 'quote-domain-core';
import { PricingItemCommercialService } from '../pricing-item/pricing-item-commercial-service';
import { singleton } from 'tsyringe';

@singleton()
export class QuoteServiceCommercialService {
    constructor(private readonly pricingItemCommercialService: PricingItemCommercialService) {
    }

    public calculateExtraPrice(quoteService: QuoteService, referentialServices: any, referential: any): void {
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCommercialService.calculateExtraPrice(pricingItem, referentialServices, referential);
        });
    }

    public calculateTheoreticalEffectif(quoteService: QuoteService, referential: any, gender: string): void {
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCommercialService.calculateTheoreticalEffectif(pricingItem, referential, gender);
        });
    }

    public calculateCollectorPrice(quoteService: QuoteService, referentialServices: any, referential: any): void {
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCommercialService.calculateCollectorPrice(pricingItem, referentialServices, referential);
        });
    }

    public calculateAdditionalConsumablePrice(quoteService: QuoteService, referentialServices: any, referential: any): void {
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCommercialService.calculateAdditionalConsumablePrice(pricingItem, quoteService.contractInfoInputs, quoteService.code, quoteService.nonNegociableArticleColor, referentialServices, referential);
        });
    }

    private forEachPricingItem(quoteService: QuoteService, callback: (pricingItem: PricingItem) => void): void {
        (quoteService.customGroups ?? []).forEach(customGroup => {
            (customGroup.pricingItems ?? []).forEach(callback);
        });
    }
}
